const ar = {
  lang: 'ar', dir: 'rtl', flag: '🇩🇿', label: 'العربية',

  nav: {
    home: 'الإعلانات', map: 'الخريطة', tools: 'الأدوات',
    messages: 'الرسائل', profile: 'ملفي', admin: 'الإدارة',
    login: 'تسجيل الدخول', register: 'إنشاء حساب', logout: 'تسجيل الخروج',
    publish: '+ نشر',
  },

  search: {
    title: 'اعثر على عقارك المثالي',
    subtitle: 'دقق بحثك في إعلاناتنا الموثوقة',
    wilaya: 'الولاية', commune: 'البلدية', type: 'نوع العقار',
    priceMin: 'السعر الأدنى (دج)', priceMax: 'السعر الأقصى (دج)',
    btn: 'بحث', reset: 'إعادة تعيين',
    results: n => `${n} إعلان`,
    verified: 'نتائج موثوقة',
    allWilayas: '— كل الولايات —',
    chooseWilayaFirst: '— اختر ولاية أولاً —',
    allTypes: '— كل الأنواع —',
  },

  annonce: {
    types: {
      appartement: 'شقة', villa: 'فيلا', studio: 'استوديو',
      bureau: 'مكتب', local: 'محل تجاري', terrain: 'أرض',
      ferme: 'مزرعة', maison: 'منزل', duplex: 'دوبليكس',
    },
    surface: 'م²', rooms: 'غرف', bathrooms: 'حمام',
    seeDetails: 'عرض التفاصيل',
    compare: 'مقارنة', selected: 'محدد',
    new: 'جديد', verified: 'موثق',
    addFav: 'إضافة للمفضلة', removeFav: 'إزالة من المفضلة',
    back: 'رجوع →',
    contact: 'التواصل مع البائع',
    call: 'اتصال', whatsapp: 'واتساب', email: 'بريد إلكتروني',
    message: 'رسالة عبر سوقناتي',
    share: 'مشاركة', similar: 'إعلانات مشابهة',
    guide: 'دليل الاقتناء',
    delete: 'حذف الإعلان',
    priceM2: 'دج/م²',
    negotiable: 'قابل للتفاوض',
    floor: 'الطابق',
    interested: 'شخص مهتم',
  },

  tools: {
    title: 'أدوات مجانية',
    subtitle: 'أدوات لمساعدتك في مشروعك العقاري',
    calcTitle: 'حاسبة القرض العقاري',
    calcDesc: 'احسب أقساطك الشهرية وفق أسعار البنوك الجزائرية.',
    estimTitle: 'تقدير قيمة العقار',
    estimDesc: 'قدّر قيمة عقارك حسب الحي والمساحة والنوع.',
    comparTitle: 'مقارنة الأحياء',
    comparDesc: 'قارن الأسعار والاتجاهات بين الأحياء.',
    calculate: 'احسب ←', estimate: 'قدّر ←', compare: 'قارن ←',

    price: 'سعر العقار (دج)', downPayment: 'الدفعة الأولى (دج)',
    duration: 'المدة (سنوات)', rate: 'معدل الفائدة',
    calcBtn: 'احسب', resetBtn: 'إعادة',
    monthly: 'القسط الشهري', totalCost: 'التكلفة الإجمالية', totalInterest: 'إجمالي الفوائد',
    amortTable: 'جدول الاستهلاك',
    month: 'الشهر', principal: 'رأس المال', interest: 'الفوائد',
    balance: 'الرصيد المتبقي',

    wilaya: 'الولاية', commune: 'البلدية / الحي', surfaceM2: 'المساحة (م²)',
    typeLogement: 'نوع السكن', etage: 'الطابق',
    estimBtn: 'تقدير القيمة', estimLoading: 'جارٍ التقدير…',
    estimResult: 'القيمة التقديرية', estimLow: 'الحد الأدنى',
    estimHigh: 'الحد الأقصى', estimPriceM2: 'متوسط السعر/م²',
    backToTools: '← الأدوات',
    quartierLabel: 'الحي', selectQuartier: 'اختر الحي',
    allTypesOption: 'كل الأنواع', roomsLabel: 'الغرف',
    estimError: 'خطأ في التقدير',
    estimFor: 'تقدير لـ',
    confHigh: 'موثوقية عالية', confMid: 'موثوقية متوسطة',
    confLow: 'موثوقية ضعيفة', confNone: 'بيانات غير كافية',
    estimatedValue: 'القيمة التقديرية',
    avgPrice: 'متوسط السعر', avgPriceM2: 'متوسط السعر / م²',
    avgSurface: 'متوسط المساحة', comparables: 'إعلانات مماثلة',
    minPrice: 'السعر الأدنى', maxPrice: 'السعر الأقصى',
    toolsDisclaimer: 'التقدير مبني على الإعلانات المنشورة في سوقناتي. لا يمثّل تقييماً رسمياً.',
    addDistrict: '+ إضافة', availableTypes: 'الأنواع المتاحة',
    nbAnnonces: 'عدد الإعلانات',
    compareBtn: 'مقارنة', comparLoading: 'جارٍ المقارنة…',
    comparError: 'خطأ في المقارنة',
  },

  auth: {
    loginTitle: 'تسجيل الدخول', registerTitle: 'إنشاء حساب',
    email: 'البريد الإلكتروني', phone: 'الهاتف', password: 'كلمة المرور',
    name: 'الاسم الكامل', firstName: 'الاسم', lastName: 'اللقب',
    loginBtn: 'دخول', registerBtn: 'إنشاء حساب',
    noAccount: 'ليس لديك حساب؟', haveAccount: 'لديك حساب بالفعل؟',
    forgotPassword: 'نسيت كلمة المرور؟',
    orLogin: 'أو',
    loginSubtitle: 'سجّل دخولك إلى حساب سوقناتي',
    registerSubtitle: 'انضم إلى سوقناتي وابحث عن عقارك المثالي',
    locked: 'الحساب مقفل مؤقتاً',
    lockedMsg: 'محاولات كثيرة. حاول بعد',
    loginLoading: 'جارٍ الدخول…', registerLoading: 'جارٍ التسجيل…',
    lockedBtn: '🔒 مقفل',
    confirmPwd: 'تأكيد',
    pwdNoMatch: 'كلمتا المرور غير متطابقتين',
    pwdTooShort: 'كلمة المرور يجب أن تحتوي على 8 أحرف على الأقل',
    connSuccess: 'تم الدخول بنجاح!', regSuccess: 'تم التسجيل بنجاح!',
    createAccount: 'إنشاء حساب', connect: 'تسجيل الدخول',
  },

  profile: {
    title: 'ملفي الشخصي', myAnnonces: 'إعلاناتي',
    stats: 'الإحصائيات', views: 'المشاهدات', contacts: 'التواصل',
    favorites: 'المفضلة', published: 'إعلانات منشورة',
    editProfile: 'تعديل الملف', save: 'حفظ',
    noAnnonces: 'لم تنشر أي إعلان بعد.',
    loading: 'جارٍ تحميل الملف…',
    personalInfo: 'المعلومات الشخصية',
    phoneNotSet: 'غير محدد', phoneVerified: '(موثق)',
    annoncesPub: 'إعلانات منشورة', memberSince: 'عضو منذ',
    verifyPhone: 'التحقق من الهاتف',
    statsSection: 'إحصائيات إعلاناتك',
    totalViews: 'إجمالي المشاهدات', contactsReceived: 'التواصل المستلم',
    inFavorites: 'في المفضلة', per30d: '/ 30ي',
    annonceCol: 'الإعلان', priceCol: 'السعر',
    statsEmpty: 'لا توجد إعلانات منشورة بعد.',
    saveBtn: 'حفظ',
  },

  messages: {
    title: 'الرسائل', noConv: 'لا توجد محادثات',
    send: 'إرسال', placeholder: 'اكتب رسالتك… (Enter للإرسال)',
    you: 'أنت',
    exchanges: 'محادثاتك مع المشترين والبائعين',
    selectConv: 'اختر محادثة',
    yesterday: 'أمس',
    disclaimer: 'لا تشارك أبداً بياناتك المصرفية. فضّل اللقاءات في أماكن عامة للزيارات.',
  },

  common: {
    loading: '...جارٍ التحميل', error: 'حدث خطأ ما',
    save: 'حفظ', cancel: 'إلغاء', delete: 'حذف',
    edit: 'تعديل', yes: 'نعم', no: 'لا', confirm: 'تأكيد',
    close: 'إغلاق', seeAll: 'عرض الكل', noResult: 'لا توجد نتائج',
    DA: 'دج', m2: 'م²',
  },

  carte: {
    title: 'خريطة الجزائر',
    subtitle: n => `استكشف ${n} حياً واكتشف المرافق`,
    accessible: 'ميسور',
    moyen: 'متوسط',
    premium: 'راقي',
    poisLabel: 'مرافق',
    scoresTitle: 'تقييم الحي',
    marketTitle: 'سوق العقارات',
    amenities: 'المرافق',
    propertyTypes: 'أنواع العقارات',
    listings: 'إعلانات',
    seeListings: q => `عرض إعلانات ${q}`,
    estimateBtn: 'تقدير قيمة عقار',
    poi: {
      ecole: 'تعليم', mosquee: 'مساجد', transport: 'مواصلات',
      commerce: 'تجارة', sante: 'صحة', parc: 'مساحات خضراء',
    },
    score: {
      transport: 'مواصلات', securite: 'أمن',
      education: 'تعليم', commerces: 'تجارة',
    },
  },

  create: {
    title: 'نشر إعلان',
    submit: 'نشر الإعلان', cancel: 'إلغاء',
    titleField: 'العنوان', description: 'الوصف',
    type: 'نوع العقار', prix: 'السعر (دج)', surface: 'المساحة (م²)',
    rooms: 'الغرف', floor: 'الطابق', photos: 'الصور',
    video: 'فيديو', docs: 'الوثائق المطلوبة',
    back: 'رجوع',
    subtitle: 'أدخل المعلومات أدناه لنشر عقارك.',
    progress: 'التقدم',
    basicInfo: 'المعلومات الأساسية',
    titleLabel: 'عنوان الإعلان',
    titlePlaceholder: 'مثال: فيلا جميلة بحديقة في حيدرة',
    descPlaceholder: 'صف عقارك: الحالة، الطابق، الاتجاه، المرافق القريبة…',
    typeLabel: 'نوع السكن',
    location: 'الموقع',
    selectWilaya: 'اختر الولاية',
    selectCommune: 'اختر البلدية',
    chooseWilayaFirst: '— اختر الولاية أولاً —',
    priceAndSize: 'السعر والأبعاد',
    priceLabel: 'السعر (دج)',
    pricePlaceholder: 'مثال: 50 000 000',
    surfaceLabel: 'المساحة (م²)',
    roomsLabel: 'الغرف',
    bathLabel: 'دورات المياه',
    mediaSection: 'الصور والفيديو',
    mediaNote: 'أضف حتى 10 صور وفيديو تعريفي. الإعلانات التي تحتوي صوراً تحصل على 5 أضعاف التواصل.',
    addPhotos: 'انقر لإضافة صور',
    photoHint: 'JPG, PNG, WEBP · حتى 10 صور · 5 MB لكل صورة',
    mainPhoto: 'الرئيسية',
    videoLabel: 'فيديو تعريفي',
    optionalLabel: '(اختياري)',
    addVideo: 'انقر لإضافة فيديو',
    videoHint: 'MP4, MOV · حتى 100 MB · 3 دقائق',
    contactSection: 'معلومات التواصل',
    contactNote: 'ستكون معلوماتك مرئية للمشترين المحتملين.',
    phoneLabel: 'الهاتف',
    emailLabel: 'البريد الإلكتروني',
    docsSection: 'الوثائق والتأكيد',
    docsNote: 'قبل النشر، أكّد أنك تمتلك الوثائق اللازمة وأن المعلومات صحيحة.',
    docsLegal: 'أي إعلان احتيالي أو مضلل يؤدي إلى تعليق فوري للحساب وقد يستوجب المساءلة القانونية.',
    submitting: 'جارٍ النشر…',
    trustNote: 'سيتم مراجعة إعلانك من قِبل فريقنا قبل النشر.',
    errorCreating: 'خطأ أثناء إنشاء الإعلان',
    docsChecklist: [
      'أمتلك سند الملكية أو عقد التملك',
      'وثيقة هوية البائع جاهزة',
      'مستخرج المسح العقاري متوفر',
      'السعر المذكور يعكس سعر البيع الحقيقي',
      'المعلومات المنشورة صحيحة ومحدّثة',
    ],
  },
};
export default ar;
